import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { PaymentAcquirerSearchService } from "./payment-acquirer-search.service";
import { Subscription } from "rxjs";
import { PaymentAcquirerSearchCriteria, PaymentAcquirerUpdateStatusCode } from "./payment-acquirer-search.model";
import { PaymentAcquirerSearch } from "src/app/core/models/payment-acquirer-model";
import { LoadingSpinnerService } from "src/app/shared/layout/loading-spinner";
import { ACTION_STATUS, ActionBarHandlerModel, ActionbarService } from "src/app/shared/ui/actionbar";
import { NewButtonModel, SaveButtonModel, CancelButtonModel, RefreshButtonModel } from "src/app/shared/ui/actionbar/models";
import { SecurityGroupService } from "src/app/core/services/system-services/security-group.service";
import { NavigationService } from "src/app/shared/utils/navigation";
import { filter } from "rxjs/operators";
import { Router } from "@angular/router";
import { PaymentAcquirerSecurityCode } from "../../payment-definition-categories";

@Component({
    selector: 'op-payment-acquirer-search',
    templateUrl: './payment-acquirer-search.component.html',
})
export class PaymentAcquirerSearchComponent implements OnInit, OnDestroy, AfterViewInit {

    actionBarHandler = new ActionBarHandlerModel(
        new NewButtonModel(),
        new SaveButtonModel(),
        new CancelButtonModel(),
        new RefreshButtonModel(),
    )

    criteria: PaymentAcquirerSearchCriteria
    results: PaymentAcquirerSearch[]

    private subscriptions: Subscription[]

    constructor(private paymentAcquirerSearchService: PaymentAcquirerSearchService,
        private loadingSpinnerService: LoadingSpinnerService,
        private actionbarService: ActionbarService,
        private securityGroupService: SecurityGroupService,
        private navigateService: NavigationService,
        private cdr: ChangeDetectorRef,
        private router: Router) {
    }
    ngOnInit(): void {
        this.results = []
        this.subscriptions = []
        this.subscriptions.push(
            this.paymentAcquirerSearchService.callSearch$
                .pipe(
                    filter(flg => !!flg)
                )
                .subscribe(() => {
                    this.subscriptions.push(
                        this.paymentAcquirerSearchService.paymentAcquirers$.subscribe(paymentAcquirers => {
                            this.results = paymentAcquirers
                        })
                    )
                    this.subscriptions.push(
                        this.paymentAcquirerSearchService.loadStatusReference().subscribe()
                    )
                })
        )
        this.subscriptions.push(
            this.paymentAcquirerSearchService.refresh$
                .subscribe(() => {
                    this.search(this.criteria)
                })
        )
    }
    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }
    ngAfterViewInit(): void {
        this.setupActionBar()

        this.subscriptions.push(
            this.securityGroupService.userSecurityGroupSecurity
                .subscribe(userSecurities => {
                    const security = userSecurities.find(s => s.securityCode == PaymentAcquirerSecurityCode);

                    if (security) {
                        this.actionBarHandler.get(ACTION_STATUS.new).enable(security.newFlag);
                        this.actionbarService.updateState(this.actionBarHandler);
                    }
                })
        )
    }

    private setupActionBar() {
        this.actionBarHandler.get(ACTION_STATUS.new).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.save).enable(false);
        this.actionBarHandler.get(ACTION_STATUS.cancel).enable(true);
        this.actionBarHandler.get(ACTION_STATUS.refresh).enable(true);
        this.actionbarService.updateState(this.actionBarHandler);
    }

    search(criteria: PaymentAcquirerSearchCriteria): void {
        if (criteria)
            this.criteria = criteria

        this.loadingSpinnerService.show()
        this.subscriptions.push(
            this.paymentAcquirerSearchService.getPaymentAcquirersSearch(this.criteria)
                .subscribe(() => {
                    this.loadingSpinnerService.hide()
                    this.cdr.markForCheck()
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    clear(): void {
        this.paymentAcquirerSearchService.clearSearch()
    }

    updateStatusCode(obj: PaymentAcquirerUpdateStatusCode): void {
        this.loadingSpinnerService.showSaving()
        this.subscriptions.push(
            this.paymentAcquirerSearchService.updateStatusCode(obj)
                .subscribe(() => {
                    this.saveCompleteAndContinue(() => {
                        this.search(this.criteria)
                    })
                },
                    () => this.loadingSpinnerService.hide())
        )
    }

    private saveCompleteAndContinue(action) {
        this.loadingSpinnerService.saveComplete()
        setTimeout(() => {
            action()
        }, 1000);
    }

    navigateDetail(params) {
        this.paymentAcquirerSearchService.saveCriteria(this.router.url.split('/')[3], this.criteria)
        this.navigateService.navigate(`/main/settings/payment-acquirer-detail`, null, false, params)
    }
}
